<template>
  <div>
    <img :src="src" width="150" height="150" style="" />
    <el-dialog
      v-model="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="hint"
    >
      <div style="text-align: center">
        <p>
          Your password does not meet relevant requirements,Please<router-link
            to="/ChangePassword"
            style="color: red"
            >click here</router-link
          >to change your password.
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
var timeStop
export default {
  name: 'Login_WeiXin',
  data() {
    return {
      src: '',
      carousel: '',
      Code: '',
      timeStop: '',
      pwdFalseShow: false,
    }
  },
  props: ['dialogVisible', 'type'],
  deactivated() {
    window.clearInterval(timeStop)
  },
  async mounted() {},
  methods: {
    handleQrcodeCheck(type) {
      //        if(type==2){
      //            let  appid = "wxdcaadfbc36ca5584";
      //   let redirect_uri = encodeURIComponent('http://beta.samsoncn.com')
      //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`

      //        }else
      if (type == 1) {
        timeStop = window.setInterval(() => {
          this.$store
            .dispatch('_getWeiXinLogin', { Scene: this.Code })
            .then((res) => {
              if (res.data.IsSuccess) {
                if (!res.data.Data.IsGo) {
                  this.pwdFalseShow = true
                  return
                }
                this.$message({ message: 'login successful', type: 'success' })
                localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
                var urldomain = '/'
                window.location.href = urldomain
                $emit(this, 'fuab', false)
              }
            })
        }, 2000)
      }
    },
  },
  emits: ['fuab'],
}
</script>

<style scoped></style>
